const messagetemplates = {
    namespaced: true,
    state: {
        usermessageList:[]
    },
    mutations: {
        updateMessageTemplates(state, newList) {
            state.usermessageList = newList
        }
    },
    actions: {
        getMessageTemplates(context , type ) {
            this._vm.$traveller_http.get('/traveller/restui/messagetemplates/getMessageTemplates', {params :{ 'type': type } })
            .then( response => {
                const data = response.data
                context.commit('updateMessageTemplates' , data )
            })
        },

        // Add new or edit 
        saveDriverTemplate(context, msg) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/messagetemplates/saveMessageTemplate', msg)
                    .then(response => {
                        context.dispatch('getMessageTemplates' , msg.type );
                        resolve(response);
                    }).catch( error => {
                    reject(error)
                    })
            });
        },

        deleteDriverMessage(context, msg ) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/messagetemplates/removeMessageTemplate', { params: { "id": (msg.id+'') } })
                    .then(response => {
                        context.dispatch('getMessageTemplates' , msg.type);
                        resolve(response);
                    }).catch(error => {
                        reject(error);
                    })
            });
        },

        //Edit order
        setDriverMessageOrder(context, msg) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/messagetemplates/setMessageTemplateOrder', { params: { "id": (msg.id+''), "order": msg.order } })
                    .then(response => {
                        context.dispatch('getMessageTemplates' , msg.type);
                        resolve(response);
                    }).catch( error => {
                        reject(error);
                    })
            });
        },
    }
}


export default messagetemplates;